import { render, staticRenderFns } from "./EmployeeTypeRep.vue?vue&type=template&id=494a8a42&"
import script from "./EmployeeTypeRep.vue?vue&type=script&lang=js&"
export * from "./EmployeeTypeRep.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeTypeRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports